let inMemoryStorage = {};

const clear = () => {
  if (isSupported()) {
    localStorage.clear();
  } else {
    inMemoryStorage = {};
  }
};

const getItem = (k) => {
  if (isSupported()) {
    if(localStorage.getItem(k) === "[object Object]") return null;
    return localStorage.getItem(k);
  }
  if (inMemoryStorage.hasOwnProperty(k)) {
    return inMemoryStorage[k];
  }
  return null;
};

const isSupported = () => {
  try {
    const testKey = "teststorage";
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

const key = (idx) => {
  if (isSupported()) {
    return localStorage.key(idx);
  }
  return Object.keys(inMemoryStorage)[idx] || null;
};

const length = () => {
  if (isSupported()) {
    return localStorage.length;
  }
  return Object.keys(inMemoryStorage).length;
};

const removeItem = (k) => {
  if (isSupported()) {
    localStorage.removeItem(k);
  } else {
    delete inMemoryStorage[k];
  }
};

const setItem = (k, v) => {
  if (isSupported()) {
    localStorage.setItem(k, v);
  } else {
    inMemoryStorage[k] = String(v);
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  clear,
  getItem,
  key,
  length,
  removeItem,
  setItem
};
